import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const darkGreenColor = '#1D4434';

/**
 * Engineering Processes admin - configuration moved to Data Imports → Full Import tab.
 * @returns {JSX.Element} EngineeringProcessesAdmin component
 */
const EngineeringProcessesAdmin = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" gutterBottom sx={{ mb: 3, color: darkGreenColor, fontWeight: 'bold' }}>
        Engineering Processes
      </Typography>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          background: 'white',
          textAlign: 'center'
        }}
      >
        <Typography variant="body1" color="text.secondary">
          Full Import configuration (Work Items, Test Case, RCA, Technical Debt) has been moved to{' '}
          <strong>Admin → Data Imports → Full Import</strong> tab.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Use that tab to configure the 4 WIQL queries and run Full Import.
        </Typography>
      </Paper>
    </Box>
  );
};

export default EngineeringProcessesAdmin;
